module.exports = __webpack_public_path__ + "static/media/cv.3e9c8763.jpg";